<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';

const emulationApi = ClientFactory.get("emulations");

export default {
  components: {
      VueGoodTable
  },
  data(){
    return {
      total: 0,
      department_name: 2,
      approver_status:"",
      full_name: "",
      self_note:"",
      department_note:"",
      time: "",
      columns: [
        {
          label: 'STT',
          field: 'rownum',
          thClass: 'text-center width-class',
          tdClass: 'text-center width-class',
        },
        {
          label: 'Tiêu chí/Nội dung',
          field: 'target_name',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Thang điểm (trừ)',
          field: 'point',
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
        {
          label: 'Điểm tự chấm',
          field: 'self_point',
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
        {
          label: 'Điểm của phòng/ban',
          field: 'department_point',
          headerField: this.checkDepartmentPoint,
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        }
      ],
       data: [
      ],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
     ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    getDetail: async function () {
      this.loading(this.$vs);
      let emulationId = this.$route.params.id || -1;
      const { data } = await emulationApi.getDetail(emulationId);
     
      this.closeLoading();
      this.checkResponseData(data);
    },
    checkDepartmentPoint(rowObj){
      return this.approver_status ===1 ? rowObj.department_point : '-';
    },
    sumCount: function (rowObj) {
      let sum = 0;
      for (let i = 0; i < rowObj.children.length; i++) {
        sum += rowObj.children[i].self_point;
      }
      return sum;
    },
    checkResponseData(data) {
      if(data.status == "success")
      {
        this.data = data.data[0].title_targets;
        this.full_name = data.data[0].emulation_info[0].full_name;
        this.department_name = data.data[0].emulation_info[0].department_name;
        this.time = data.data[0].emulation_info[0].time;
        this.self_note = data.data[0].emulation_info[0].self_note;
        this.department_note = data.data[0].emulation_info[0].department_note;
        this.approver_status  = data.data[0].emulation_info[0].approver_status;

        let sumPoint=0,sumSelfPoint = 0, sumDepartmentPoint = 0;
        this.data.forEach(x => {
          sumPoint += x.point!= null ? x.point : 0;
          sumSelfPoint += x.self_point!= null ? x.self_point : 0;
          sumDepartmentPoint += x.department_point!= null ? x.department_point : 0;
        });
        this.data.push({
          rownum: this.data.length+1,
          target_id: null, 
          target_parent_id: null, 
          target_name: 'TỔNG ĐIỂM',
          point: sumPoint,
          self_point: sumSelfPoint,
          department_point: sumDepartmentPoint,
          is_title: 1,
          children: []
        });
      }else{
        this.notify({
          error:true,
          title: data.status,
          text: data.message
        });
      }
     },

    rowStyleClassFn(row) {
      if (row.is_title > 0)
        return 'header-row';
      else{
        return (this.approver_status === 1 && row.department_point !== row.self_point) ? 'green' : '';
      }

        return 'green'
      //return row.department_point > 18 ? 'green' : 'red';
      //return row.is_title > 0 ? 'header-row' : '';
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
  destroyed() {
    this.closeLoading();
  }
};

</script>

<template>
  <div class="self_rating_detail">
    <CCard class= "mb-2">
      <CCardHeader  class="pt-1 pb-1">
          <h4>Chấm điểm thi đua tháng</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-2">
        <CRow>
            <CCol sm="4">
              <span>Nhân viên: {{ this.full_name }}</span>
            </CCol>
            <CCol sm="4">
              <span>Phòng ban: {{ this.department_name }}</span>
            </CCol>
            <CCol sm="4" class="text-right">
              <span>Tháng: {{this.time}}</span>
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
        <vue-good-table
          :columns="columns"
          :rows="data" 
          :group-options="{
            enabled: true,
            headerPosition: 'top'
          }"
          :sort-options="{
            enabled:false
          }"
          
          :row-style-class="rowStyleClassFn"
        >
          <div slot="emptystate">
            Không có dữ liệu
          </div>
          <template
            slot="table-row"
            slot-scope="props"
          >
              <div v-if="props.column.field === 'point'">
                  <span> {{props.row.is_title != 1 ? `-${props.row.point}` :  props.row.point}}</span>
              </div>
              <div v-else-if="props.column.field === 'department_point'">
                <span> {{approver_status !== 1 ? `-` :  props.row.department_point}}</span>
              </div>
          </template>
        </vue-good-table> 
        <CRow>
        <CCol sm="6">
          <CTextarea
            label="Ghi chú cá nhân"
            placeholder="Nhập ghi chú"
            :value.sync="self_note"
            :disabled="true"
            class="p-2"
            />
        </CCol>
        <CCol sm="6">
          <CTextarea
            label="Ghi chú lãnh đạo"
            placeholder="Nhập ghi chú"
            :value.sync="department_note"
            :disabled="true"
            class="p-2"
            />
        </CCol>
      </CRow>
            
    </CCard>
     <vs-button square class="mb-3 custom_btn_search" @click="()=> {this.$router.go(-1)}"><i class='bx bx-left-arrow-alt'></i> &nbsp; Quay lại</vs-button>
  </div>
</template>


<style lang="scss">
    .self_rating_detail{
      .width-class{
        min-width: 3px !important;
      }
      .width-point{
        min-width: 30px !important;
      }
      .header-row {
        background: #f7f8f9;
        color: rgb(250, 9, 9);
        font-weight: bold;
        padding: .75em .75em .75em .75em !important;
      }
      
      .vs-checkbox-content{
        align-items: center;
        justify-content: center;
      }
      .checkbox-left{
        text-align: left;
      }
      .green{
        background-color:#99ffcc;
      }
    }
</style>